import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API_ENDPOINTS from "../../utils/apiEndpoints";

const ParentLogin = () => {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // 'success' or 'error'
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    try {
      const res = await fetch(API_ENDPOINTS.PARENT_LOGIN, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: formData.username,
          password: formData.password,
        }),
      });

      const data = await res.json();
      // console.log(data, "response");

      if (res.ok && data.message === "Login successful") {
        // Save token
        localStorage.setItem("parentToken", data.access_token);

        setMessage(data.message);
        setMessageType("success");
        setFormData({ username: "", password: "" });

        // Delay navigation
        setTimeout(() => {
          navigate("/dashboard");
        }, 1500);
      } else {
        // Handle validation error messages
        let errorMsg = data.message || "Login failed.";
        if (data.data && typeof data.data === "object") {
          const errors = Object.values(data.data)
            .flat()
            .join(" ");
          errorMsg += " " + errors;
        }

        setMessage(errorMsg);
        setMessageType("error");
      }
    } catch (error) {
      setMessage("Something went wrong.");
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <div className="w-screen min-h-screen flex items-center justify-center bg-gray-50 px-4 sm:px-6 lg:px-8">
        <div className="relative py-3 sm:max-w-xs sm:mx-auto">
          <div className="min-h-96 px-8 py-6 mt-4 text-left bg-white rounded-xl shadow-lg">
            <div className="flex flex-col justify-center items-center h-full select-none">
              <div className="flex flex-col items-center justify-center gap-2 mb-6">
                <svg className="w-8" viewBox="0 0 64 64" fill="none">
                  <path d="M40.955 8H17C13.6863 8 11 10.6863 11 14V49.94C11 53.2537 13.6863 55.94 17 55.94H40.955C44.2687 55.94 46.955 53.2537 46.955 49.94V14C46.955 10.6863 44.2687 8 40.955 8Z" stroke="#000000" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"></path>
                  <path d="M34.971 26.011L28.978 31.97L34.971 37.996" stroke="#426AB2" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"></path>
                  <path d="M28.978 31.97H52.947" stroke="#426AB2" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"></path>
                </svg>
                <p className="m-0 text-[16px] font-semibold">Parent Login</p>
                <span className="m-0 text-xs max-w-[90%] text-center text-[#8B8E98]">
                  Enter your credentials to access your account.
                </span>
              </div>

              {message && (
                <p className={`text-sm mb-4 ${messageType === "success" ? "text-green-600" : "text-red-600"}`}>
                  {message}
                </p>
              )}

              <form onSubmit={handleSubmit} className="w-full flex flex-col gap-3">
                <div>
                  <label className="font-semibold text-xs text-gray-400">username</label>
                  <input
                    type="text"
                    name="username"
                    required
                    value={formData.username}
                    onChange={handleChange}
                    placeholder="username"
                    className="border rounded-lg px-3 py-2 text-sm w-full outline-none"
                  />
                </div>

                <div>
                  <label className="font-semibold text-xs text-gray-400">Password</label>
                  <input
                    type="password"
                    name="password"
                    required
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="********"
                    className="border rounded-lg px-3 py-2 text-sm w-full outline-none"
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="mt-1 py-2 bg-blue-500 hover:bg-blue-700 focus:ring-offset-blue-200 text-white w-full transition ease-in duration-200 text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg cursor-pointer"
                >
                  {loading ? "Logging in..." : "Login"}
                </button>
                <p>
                  Not Registered? <span><a href="/register" className="text-blue-700">Register Now</a></span>
                </p>
                <p>
                  Forgot Password? <span><a href="tel:6360099621" className="text-blue-700">Contact:63600 99621</a></span>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ParentLogin;
